import type {CopyActionProps} from "./types";
import {CopyIcon} from "../../../../../ui/components/icons";

export const CopyAction = ({onClick}: CopyActionProps) => {
  return (
    <CopyIcon onClick={onClick}/>
  );
};